import { cardItems } from '@/mocks/homeData';

const cardImageUrls: string[] = [
  'https://readdy.ai/api/search-image?query=Mysterious%20urban%20night%20scene%20illustration%20in%20Korean%20webtoon%20style%2C%20neon%20signs%20reflecting%20on%20wet%20street%2C%20moody%20atmospheric%20lighting%2C%20dark%20blue%20and%20warm%20orange%20contrast%2C%20cinematic%20composition&width=700&height=500&seq=card-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Enchanted%20forest%20fantasy%20illustration%20with%20glowing%20fireflies%20and%20magical%20creatures%2C%20lush%20greenery%20with%20soft%20golden%20light%20rays%2C%20whimsical%20atmosphere%2C%20detailed%20natural%20elements%2C%20ethereal%20fantasy%20art%20style&width=700&height=500&seq=card-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Delicious%20food%20illustration%20with%20adventure%20elements%2C%20steaming%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20appetizing%20composition%2C%20cozy%20and%20inviting%20atmosphere%2C%20Japanese%20anime%20food%20art%20style&width=700&height=500&seq=card-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Futuristic%20mecha%20robot%20illustration%20standing%20in%20urban%20landscape%2C%20detailed%20mechanical%20design%2C%20dramatic%20sunset%20lighting%2C%20cinematic%20composition%2C%20warm%20golden%20hour%20tones%2C%20sci-fi%20anime%20art%20style&width=700&height=500&seq=card-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Peaceful%20school%20campus%20scene%20with%20cherry%20blossom%20trees%2C%20students%20walking%20on%20path%2C%20warm%20spring%20sunlight%2C%20nostalgic%20and%20gentle%20atmosphere%2C%20soft%20pink%20and%20cream%20color%20palette%2C%20slice%20of%20life%20anime%20style&width=700&height=500&seq=card-05&orientation=landscape',
];

export default function SectionCards() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/70 text-primary-700 text-xs font-medium mb-4">
            <i className="ri-bookmark-line"></i>
            <span>编辑推荐</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">精选推荐</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            编辑团队精心挑选的高品质漫画推荐
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {cardItems.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200/60 transition-colors duration-200 group cursor-pointer">
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-secondary-100">
                <img
                  src={cardImageUrls[i]}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-2 left-2">
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-background-50/90 text-foreground-800 backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}